import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/MatchDebugger.vue"),
    meta: {
      title: "Match Debugger",
    },
    name: "match-debugger",
    path: "/match-debugger",
    props: (route) => typecastRouteProps(route),
  },
];
